import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Routes, Route } from 'react-router-dom';
import './index.scss';
import LeftMenu from './components/left-menu';
import NavbarV2 from '@/components/navbar-v2';
import agentPageStore from './store';
import SquarePage from './components/square-page';
import SquareAgent from '../square-agent';
import MyAgent from './components/my-agent';
import slsLogger from '@public/log/sls';
import McpSquare from '../mcp-square';
import userStore from '@/store/user';
import { HelpOther } from '@/common/helper';
import client from '@/store/client';


const AgentPage = observer(props => {
  useEffect(() => {
    // 360se，弹登录
    if (client.isSeLLQ && !userStore.isUser) {
      HelpOther.toast("请先登录", "info");
      userStore.gotoLogin();
    }

    agentPageStore.getAgents(true);
    // agentPageStore.getWorkFlowAgents(true);
    slsLogger.log({
      key : "aiagent",
      action : "show",
    });
  }, []);

  return (
    <div className={['size-full overflow-x-auto flex ']}>
      <NavbarV2 scene="aigent"/>
      <div className="flex-grow w-0 h-full ">
        <Routes>
          <Route index element={<SquarePage />} />
          <Route path="mine" element={<MyAgent />} />
          <Route path="case" element={<SquareAgent />} />
          <Route path="mcpsquare" element={<McpSquare />} />
        </Routes>
      </div>
    </div>
  );
});

export default AgentPage;
